import {InvoiceLine,type InvoiceLineData} from "@/types/invoices/InvoiceLine";
import {CustomerLedgerEntry,type CustomerLedgerEntryData} from "@/types/erp/customerLedgerEntry";

export class Invoice {
    public id: number | null;
    public customer_ledger_entry_id:  number | null ;
    public consignor_company_code: string ;
    public outgoing_invoice_seq: string ;
    public outgoing_invoice_legal_invoice_no: string ;
    public outgoing_invoice_status: string ;
    public outgoing_invoice_description2: string ;
    public document_path: string|null;
    public document_name: string|null;
    public createdAt: Date|null;
    public invoiceLines:InvoiceLine [];
    public customerLedgerEntry:CustomerLedgerEntry|null;

    constructor(data: InvoiceData | void) {
        if (data === undefined) {
            this.id = null;
            this.customer_ledger_entry_id = null;
            this.consignor_company_code = "";
            this.outgoing_invoice_seq = "";
            this.outgoing_invoice_legal_invoice_no = "";
            this.outgoing_invoice_status = "";
            this.outgoing_invoice_description2 = "";
            this.document_path = "";
            this.document_name = "";
            this.createdAt = null;
            this.invoiceLines = [];
            this.customerLedgerEntry = null;

        } else {
            this.id = data.id;
            this.customer_ledger_entry_id = data.customer_ledger_entry_id;
            this.consignor_company_code = data.consignor_company_code;
            this.outgoing_invoice_seq = data.outgoing_invoice_seq;
            this.outgoing_invoice_legal_invoice_no = data.outgoing_invoice_legal_invoice_no;
            this.outgoing_invoice_status = data.outgoing_invoice_status;
            this.outgoing_invoice_description2 = data.outgoing_invoice_description2;
            this.document_path = data.document_path;
            this.document_name = data.document_name;
            this.createdAt = data.createdAt;
            this.invoiceLines = [];
            if (data.invoiceLines !== undefined) {
                data.invoiceLines.forEach(invoiceLine => this.invoiceLines.push((new InvoiceLine(invoiceLine))));
            }
            this.customerLedgerEntry = null;
            if (data.customerLedgerEntry !== undefined && data.customerLedgerEntry !== null) {
                this.customerLedgerEntry = new CustomerLedgerEntry(data.customerLedgerEntry)
            }
        }
    }

}

export type InvoiceData = {
    id: number | null;
    customer_ledger_entry_id:  number | null ;
    consignor_company_code: string ;
    outgoing_invoice_seq: string ;
    outgoing_invoice_legal_invoice_no: string ;
    outgoing_invoice_status: string ;
    outgoing_invoice_description2: string ;
    document_path: string ;
    document_name: string ;
    createdAt: Date|null;
    invoiceLines:InvoiceLineData[];
    customerLedgerEntry:CustomerLedgerEntryData|null;
}